// The by-job hub: the search box narrows by name or description, the sort
// buttons reorder. Everything is already in the page, so nothing is
// fetched. A kind of work has a page of its own (/tasks/group/{slug}/),
// which the rail links to.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "sort", "card", "grid", "count", "empty"]
  static values = { one: String, other: String }

  connect() {
    this.sort = "tools"
    // Words typed on a group or job page arrive as ?q=.
    if (this.hasQueryTarget && this.queryTarget.value.trim() !== "") this.apply()
  }

  pickSort(event) {
    this.sort = event.currentTarget.dataset.sort
    this.sortTargets.forEach((el) => el.setAttribute("aria-pressed", el.dataset.sort === this.sort ? "true" : "false"))
    this.apply()
  }

  apply() {
    const query = (this.hasQueryTarget ? this.queryTarget.value : "").trim().toLowerCase()
    let shown = 0

    this.cardTargets.forEach((card) => {
      const visible = query === "" || card.dataset.text.includes(query)
      card.hidden = !visible
      if (visible) shown += 1
    })

    const cards = this.cardTargets.slice().sort((a, b) => {
      if (this.sort === "name") return a.dataset.name.localeCompare(b.dataset.name)
      return Number(b.dataset.count) - Number(a.dataset.count) || a.dataset.name.localeCompare(b.dataset.name)
    })
    cards.forEach((card) => this.gridTarget.appendChild(card))

    if (this.hasCountTarget) this.countTarget.textContent = (shown === 1 ? this.oneValue : this.otherValue).replace("%{count}", shown)
    if (this.hasEmptyTarget) this.emptyTarget.hidden = shown !== 0
  }
}
